import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";
import { formatDateCell, formatUnitOfProductSoldFromRow } from "../approvalTableFormatters";

const mapUseOfSoldApprovalRow = (item) => ({
  ...item,
  dateOfSaleDisplay: formatDateCell(item?.dateOfSale),
  unitOfProductSoldDisplay: formatUnitOfProductSoldFromRow(item),
  productName:
    item?.productName ??
    item?.productMaster?.productName ??
    item?.product?.productName ??
    "",
  productIdOrSku:
    item?.productIdOrSku ??
    item?.productId ??
    item?.productMaster?.productId ??
    "",
  requestStatus: item?.requestStatus ?? item?.approvalStatus ?? "",
});

const USE_OF_SOLD_EDIT_VALUE_KEYS_OMIT = [
  "averageAnnualEnergyConsumptionPerUnit",
  "avgAnnualEnergyConsumptionPerUnit",
  "typicalOperatingHours",
  "recyclableComponentsPercentage",
  "designedForReuseRecyclingDisposal",
  "isProductDesignedForReuseRecyclingDisposal",
  "productId",
];

const UseOfSoldView = (props) => (
  <SimpleScope3ApprovalDrawer
    {...props}
    title="Use of sold products — change request"
    omitEditValueKeys={USE_OF_SOLD_EDIT_VALUE_KEYS_OMIT}
  />
);

const UseOfSoldProductsApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    { title: "Product Name", key: "productName" },
    { title: "Product ID / SKU", key: "productIdOrSku" },
    // { title: "Unit of Product Sold", key: "unitOfProductSoldDisplay" },
    { title: "Date of Sale", key: "dateOfSaleDisplay" },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="Use of Sold Products"
      apiSegment="useOfSoldProducts"
      ViewPage={UseOfSoldView}
      headings={headings}
      columnWidth={
        user?.companyAdmin
          ? "10% 10% 14% 14% 14% 12% 12% 8%"
          : "11% 16% 16% 16% 14% 14% 8%"
      }
      mapRow={mapUseOfSoldApprovalRow}
    />
  );
};

export default UseOfSoldProductsApproval;
